<template>
  <div
    v-if="homePage"
    class="home content ql-editor"
    v-html="homePage"
  />
  <Live v-else />
</template>

<script>
  import Live from '@/views/Live';
  import { PortalService } from '@/utils/portal-service';

  export default {
    name: 'Home',
    components: { Live },
    data() {
      return {
        homePage: null,
      };
    },
    created() {
      PortalService.getHomePage()
        .then(res => {
          if (res.data.type === 'PAGE') {
            this.homePage = res.data.content;
          }
        });
    },
  };
</script>
